var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "defult",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  { attrs: { label: "设备类型:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.form.search_depend_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "search_depend_type", $$v)
                          },
                          expression: "form.search_depend_type",
                        },
                      },
                      _vm._l(_vm.deviceNameObj, function (item, index) {
                        return _c("el-option", {
                          attrs: { label: index, value: item },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "手机号码:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_mobile,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_mobile", $$v)
                        },
                        expression: "form.search_mobile",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { label: "商户名称:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_store_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_store_name", $$v)
                        },
                        expression: "form.search_store_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-down",
                    attrs: { label: "设备SN:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_goods_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_goods_sn", $$v)
                        },
                        expression: "form.search_goods_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-down",
                    attrs: { label: "时间筛选:" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "开始",
                            "value-format": "yyyy-MM-dd HH:hh:ss",
                            "picker-options": _vm.beginOptions,
                          },
                          model: {
                            value: _vm.form.begin,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "begin", $$v)
                            },
                            expression: "form.begin",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "结束",
                            "value-format": "yyyy-MM-dd HH:hh:ss",
                            "picker-options": _vm.endOptions,
                          },
                          model: {
                            value: _vm.form.end,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "end", $$v)
                            },
                            expression: "form.end",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", "native-type": "submit" } },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery(1)
                          },
                        },
                      },
                      [
                        _vm._v("重置"),
                        _c("i", {
                          staticClass: "el-icon-refresh el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content:
                            "选择开始时间和结束时间,点击查询后即可导出该时间段内的订单",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.outTable()
                              },
                            },
                          },
                          [
                            _vm._v("导出"),
                            _c("i", {
                              staticClass: "el-icon-male el-icon--right",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "more",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-up",
                    attrs: { label: "商户名称:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_store_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_store_name", $$v)
                        },
                        expression: "form.search_store_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-up",
                    attrs: { label: "设备SN:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_goods_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_goods_sn", $$v)
                        },
                        expression: "form.search_goods_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-up",
                    attrs: { label: "时间筛选:" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "开始",
                            "value-format": "yyyy-MM-dd HH:hh:ss",
                            "picker-options": _vm.beginOptions,
                          },
                          model: {
                            value: _vm.form.begin,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "begin", $$v)
                            },
                            expression: "form.begin",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                        _vm._v(" "),
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "结束",
                            "value-format": "yyyy-MM-dd HH:hh:ss",
                            "picker-options": _vm.endOptions,
                          },
                          model: {
                            value: _vm.form.end,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "end", $$v)
                            },
                            expression: "form.end",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "p-5" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "mb-0 bg-white",
              attrs: { type: "card" },
              on: { "tab-click": _vm.typeClick },
              model: {
                value: _vm.listQuery.deal_status,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "deal_status", $$v)
                },
                expression: "listQuery.deal_status",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: {
                  label: "全部(" + (_vm.numInfo.all_num || 0) + ")",
                  name: "3",
                },
              }),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: {
                  label: "未处理(" + (_vm.numInfo.sended_num || 0) + ")",
                  name: "0",
                },
              }),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: {
                  label: "处理中(" + (_vm.numInfo.dealing_num || 0) + ")",
                  name: "1",
                },
              }),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: {
                  label: "已处理(" + (_vm.numInfo.dealed_num || 0) + ")",
                  name: "2",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bg-white" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "list_table",
                  staticClass: "ptd-5",
                  attrs: {
                    id: "list_table",
                    data: _vm.list,
                    "max-height": _vm.tableMaxH,
                    "element-loading-text": "Loading",
                    stripe: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "身份", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row.from_type == 0 ? "代理商" : "用户"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v("ID:" + _vm._s(scope.row.from_id)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "用户昵称", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex align-center" },
                              [
                                _c("el-avatar", {
                                  attrs: {
                                    size: "small",
                                    src: scope.row.from_avatar,
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1 ml-5" }, [
                                  _vm._v(_vm._s(scope.row.from_name)),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "联系电话", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.mobile || "--") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "问题类型", width: "110" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(_vm._s(_vm.issueArr[scope.row.type])),
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(scope.row.user_type))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商户", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.store_name) +
                                " "
                            ),
                            scope.row.door
                              ? _c("span", [
                                  _vm._v(
                                    "(房间号：" + _vm._s(scope.row.door) + ")"
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "二维码", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(_vm._s(scope.row.sao_device_sn)),
                            ]),
                            _vm._v(" "),
                            scope.row.order_sn
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "text-blue",
                                    attrs: {
                                      href:
                                        "/order/order?order_sn=" +
                                        scope.row.order_sn,
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v("查看订单")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "设备类型", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.depend_type == 1
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.support_buletooth == 1
                                        ? "蓝牙线"
                                        : "密码线"
                                    )
                                  ),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.deviceKeyObj[scope.row.depend_type]
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "反馈内容", width: "220" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.content || "--") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "错误截图", width: "190" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex flex-wrap" },
                              _vm._l(scope.row.img_url, function (item) {
                                return _c("el-image", {
                                  staticClass: "mr-5",
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                  },
                                  attrs: {
                                    src: item,
                                    "preview-src-list": scope.row.img_url,
                                  },
                                })
                              }),
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "反馈时间", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.parseTime(
                                    scope.row.add_date,
                                    "{m}-{d} {h}:{i}"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "身份", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.from_type == 0 ? "代理商" : "用户"
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "回复", "min-width": "250" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "fs-s1 text-gray" },
                              _vm._l(scope.row.reply_list, function (item) {
                                return _c("div", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.parseTime(
                                          item.add_date,
                                          "{m}-{d} {h}:{i}"
                                        )
                                      ) +
                                      "回复：" +
                                      _vm._s(item.content) +
                                      "\n              "
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "备注", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.remark) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "ml-0",
                                attrs: {
                                  type: "primary",
                                  plain: "",
                                  round: "",
                                  size: "mini",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.replyDialog = true
                                    _vm.issue = scope.row
                                  },
                                },
                              },
                              [_vm._v("回复")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticClass: "ml-0",
                                attrs: {
                                  type: "primary",
                                  plain: "",
                                  round: "",
                                  size: "mini",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.deal_status = scope.row.deal_status
                                    _vm.remark = scope.row.remark
                                    _vm.dealDialog = true
                                    _vm.issue = scope.row
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.statusObj[scope.row.deal_status])
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.outStatus
                ? _c(
                    "div",
                    { staticClass: "flex justify-center" },
                    [
                      _c("pagination", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.listQuery.page_num > 0,
                            expression: "listQuery.page_num > 0",
                          },
                        ],
                        attrs: {
                          page: _vm.listQuery.start,
                          limit: _vm.listQuery.limit,
                          "page-count": _vm.listQuery.page_num,
                        },
                        on: {
                          "update:page": function ($event) {
                            return _vm.$set(_vm.listQuery, "start", $event)
                          },
                          "update:limit": function ($event) {
                            return _vm.$set(_vm.listQuery, "limit", $event)
                          },
                          pagination: _vm.getList,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "问题处理", visible: _vm.dealDialog },
          on: {
            "update:visible": function ($event) {
              _vm.dealDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "auto" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "状态：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.deal_status,
                        callback: function ($$v) {
                          _vm.deal_status = $$v
                        },
                        expression: "deal_status",
                      },
                    },
                    _vm._l(_vm.statusObj, function (item, index) {
                      return _c(
                        "el-radio",
                        { attrs: { label: Number(index) } },
                        [_vm._v(_vm._s(item))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注：" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 4 },
                    model: {
                      value: _vm.remark,
                      callback: function ($$v) {
                        _vm.remark = $$v
                      },
                      expression: "remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deal()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "问题回复", visible: _vm.replyDialog },
          on: {
            "update:visible": function ($event) {
              _vm.replyDialog = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: { type: "textarea", rows: "4" },
            model: {
              value: _vm.replyObj.content,
              callback: function ($$v) {
                _vm.$set(_vm.replyObj, "content", $$v)
              },
              expression: "replyObj.content",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.reply()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }